import styled from "styled-components";

export const Container = styled.div`
background-color: ${({ color }) => color || '#d3d3d3'};
  padding: 4px;
  border-radius: 4px;
  font-weight: 600;
  color: #fff;
`;
